import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getMarcas,
  deleteMarca as borrarMarca,
  getMarcaById,
} from "../helpers/rutaMarcas";
import ModalMarca from "./ModalMarca";
import "../css/tableclientes.css";

const TableMarcas = () => {
  const [marcas, setMarcas] = useState({
    data: { marcas: [] },
    loading: true,
  });

  const [marca, setMarca] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaMarcas();
  }, []);

  const consultaMarcas = async () => {
    try {
      const datos = await getMarcas({ page: 1, limit: 1000 });

      console.log("Marcas:", datos);

      setMarcas({
        data: datos || { marcas: [] },
        loading: false,
      });
    } catch (error) {
      console.error("Error al consultar marcas:", error);

      setMarcas({
        data: { marcas: [] },
        loading: false,
      });
    }
  };

  const handleClose = () => {
    setShow(false);
    consultaMarcas();
  };

  const handleShow = () => setShow(true);

  const modificaMarca = async (id) => {
    try {
      const resp = await getMarcaById(id);

      console.log("Marca seleccionada:", resp);

      setMarca(resp);
      handleShow();
    } catch (error) {
      console.error("Error al buscar marca:", error);
      alert("No se pudo obtener la marca.");
    }
  };

  const eliminarMarca = async (id) => {
    const validar = window.confirm("¿Está seguro que desea borrar la marca?");

    if (!validar) return;

    try {
      await borrarMarca(id);
      consultaMarcas();
    } catch (error) {
      console.error("Error al borrar marca:", error);
      alert("No se pudo borrar la marca.");
    }
  };

  const rows = (marcas.data?.marcas || [])
    .filter((m) => m?.activo ?? true)
    .sort((a, b) => {
      const A = (a?.nombre || a?.marca || "").toString().trim();
      const B = (b?.nombre || b?.marca || "").toString().trim();

      return A.localeCompare(B, "es", { sensitivity: "base" });
    });

  return (
    <div className="table-container">
      {!marcas.loading && (
        <>
          <div className="col-12 mt-4"></div>

          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th className="cli">Marcas</th>
                  <th>Modif/Eliminar</th>
                </tr>
              </thead>

              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={2} className="text-center">
                      No hay marcas.
                    </td>
                  </tr>
                ) : (
                  rows.map((marca) => (
                    <tr key={marca._id}>
                      <td>{marca.nombre || marca.marca || "-"}</td>

                      <td>
                        <button
                          id="acepto"
                          className="btn btn-primary"
                          onClick={() => modificaMarca(marca._id)}
                        >
                          <i
                            className="fa fa-pencil-square-o"
                            aria-hidden="true"
                          ></i>
                        </button>

                        <button
                          id="acepto"
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarMarca(marca._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>

          <ModalMarca show={show} handleClose={handleClose} marca={marca} />
        </>
      )}
    </div>
  );
};

export default TableMarcas;